import styled from 'styled-components';
import { Box } from '@mui/material';

export const StatusDescriptionBox = styled(Box)`
  padding: 16px;
  margin-top: 16px;
  background-color: #ffffff; /* O ${({ theme }) => theme.palette?.background?.paper || '#fff'} */
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette?.divider || '#e0e0e0'};
`;
